import React, { useState} from 'react';
import * as Yup from "yup";
import { useForm} from "react-hook-form";
import {connect, useSelector} from 'react-redux'
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import {getStateByPath} from "../../../redux/selectors";

// components
import Separator from "../../../components/Separator";
import SelectGeneric from "../../../components/select/selectGeneric";
import {GenericButton} from "../../../components/buttons/customButtons";

// labels
import {TT_CLOSE, TT_SAVE} from "../../../components/i18n/toolTips";

// actions
import {setDataToEdit, setEditMode, setEnabledForm, setFormInfo} from "../../../redux/actions/genericActions";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";

// services & providers
import {menuService} from "../../../jwt/_services";
import {MAX_NAME, REQUIRED} from "../../../components/i18n/i18n";
import {MAX_NAME_SIZE} from "../../../components/menu-flower/constants";
import {SelectWithIcon} from "../../../components/select/selectWithIcon";
import {applicativeProvider} from "../../../providers/applicativeProvider";

const MenuForm = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { editMode, domainObject, category } = componentState?.data;

    const [icon, setIcon] = useState(  domainObject?.icon  || null);
    const [appId, setAppId] = useState(domainObject?.app?.id || null);


    const validationSchema = Yup.object().shape({
        code: Yup.string().required(REQUIRED),
        name: Yup.string().required(REQUIRED).max(MAX_NAME_SIZE, MAX_NAME),
        url:  Yup.string().required(REQUIRED)
    });

    const {register, handleSubmit, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            name            : domainObject?.name,
            code            : domainObject?.code,
            url             : domainObject?.url,
            description     : domainObject?.description,
            categoryCode    : domainObject?.categoryCode,
        }
    });

    const onSubmit = (data, _) => {
        let dataRequest = {
            ...data,
        }

        if (icon)
            dataRequest.icon =  icon.id;

        if (appId)
            dataRequest.app = { id : appId }
        else
            dataRequest.app = null

        if (!editMode) {
            // console.log('save',  dataRequest);
            // return;
            genericIndexedActions.save(path, menuService, dataRequest)
        }
        else {
            let id = domainObject.id;
            dataRequest.id = domainObject?.id
            // console.log('update',  dataRequest);
            // return;
            genericIndexedActions.update(path, menuService, id, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => props.onClose()

    return <Form onSubmit={handleSubmit(onSubmit)}>
        <Card className={ 'card-modal-small' }>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <>
                    <h2 className={'card-modal-title'}> {(domainObject?.title || domainObject?.name || '')}</h2>
                    <br/>
                </>
                <div className={'top-right'}>
                    <GenericButton
                        style={'table'}
                        icon={'fa-save'}
                        toolTip={TT_SAVE}
                        permission={'add'}
                        type={'submit'}
                    />
                    <Separator/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_CLOSE}
                        icon={'fa-times'}
                        permission={'search'}
                        onClick={closeForm}
                    />
                </div>
            </CardTitle>
            <CardBody className={'card-body-modal'}>
                <Row>
                    <Col md="6">
                        <FormGroup>
                            <Label className={(errors.code ? 'label-is-invalid' : '')}>Codigo</Label>
                            <Input type="text" name="code"
                                   placeholder="{app}_{clase}"
                                   innerRef={register}
                                   className={(errors.code ? ' is-invalid' : '')}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="6">
                        <FormGroup>
                            <Label className={(errors.code ? 'label-is-invalid' : '')}>Nombre</Label>
                            <Input type="text" name="name"
                                   placeholder="Ingrese nombre"
                                   innerRef={register}
                                   className={(errors.name ? ' is-invalid' : '')}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="6">
                        <FormGroup>
                            <Label>Icono</Label>
                            <SelectWithIcon name="icon"
                                            innerRef={register}
                                            ref={register}
                                            value={icon}
                                            onChange={ value => setIcon(value) }/>
                        </FormGroup>
                    </Col>
                    <Col md="6">
                        <FormGroup>
                            <Label>App</Label>
                            <br/>
                            <SelectGeneric
                                initialValue={ appId }
                                setExternalValue={ setAppId }
                                provider={ applicativeProvider }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="6">
                        <FormGroup>
                            <Label >Componente</Label>
                            <Input type="text" name="url"
                                   placeholder="Identificador de vista"
                                   innerRef={register}
                                   className={(errors.url ? ' is-invalid' : '')}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="6">
                        <FormGroup>
                            <Label>Codigo de Categoria agrupadora</Label>
                            <Input type="text"
                                   name="categoryCode"
                                   placeholder="Ingrese codigo"
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="12">
                        <FormGroup>
                            <Label>Descripción</Label>
                            <Input type="textarea"
                                   rows="5"
                                   name="description"
                                   placeholder="Ingrese una descripción"
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    </Form>
}

const mapStateToProps = state => ({})

const mapActionsToProps = ({
    setFormInfo,
    setDataToEdit,
    setEnabledForm,
    setEditMode
})

export default connect(mapStateToProps, mapActionsToProps)(MenuForm)